import wixUsers from "wix-users";

/** Edit this if you keep a single menu and want to strip exact labels */
const ADMIN_LABELS = [
  "Admin Portal",
  "Admin Reservations",
  "Admin Booking",
  "Admin Member"       // add/remove labels as needed (must match exactly)
];

/** Role names that count as privileged (case-insensitive contains “admin”) */
function isPrivileged(roles = []) {
  return roles.some(r => /admin/i.test(r?.name || ""));
}

function getEl(id) {
  try { return $w(id); } catch { return null; }
}

$w.onReady(async () => {
  // Detect available menus
  const menuAdmin  = getEl("#siteMenuAdmin");   // 👈 give your admin-only menu this ID
  const menuPublic = getEl("#siteMenuPublic");  // 👈 give your public menu this ID
  const singleMenu = getEl("#siteMenu1");       // 👈 fallback: your original single menu ID

  // Log items (for label confirmation)
  const logItems = (menu, tag) => {
    try {
      if (menu?.items) {
        console.log(`[masterPage] ${tag} items =>`, menu.items);
      }
    } catch {}
  };

  if (menuAdmin)  logItems(menuAdmin,  "siteMenuAdmin");
  if (menuPublic) logItems(menuPublic, "siteMenuPublic");
  if (singleMenu) logItems(singleMenu, "siteMenu1");

  // Default state: show public, hide admin (or keep single visible)
  try { menuAdmin?.collapse(); } catch {}
  try { menuPublic?.expand();  } catch {}

  // If not logged in, we can stop here for dual-menu setups
  let roles = [];
  try {
    if (wixUsers.currentUser.loggedIn) {
      roles = await wixUsers.currentUser.getRoles();
    }
  } catch (e) {
    console.warn("[masterPage] getRoles error:", e);
  }

  const canSeeAdmin = isPrivileged(roles);

  // Dual-menu approach (recommended): toggle menus cleanly
  if (menuAdmin && menuPublic) {
    if (canSeeAdmin) {
      menuPublic.collapse?.();
      menuAdmin.expand?.();
    } else {
      menuAdmin.collapse?.();
      menuPublic.expand?.();
    }
    return; // done
  }

  // Single-menu fallback (best-effort):
  // Try to hide admin-only entries by filtering menu.items by label.
  if (singleMenu) {
    // If user is not privileged, attempt to strip labels listed in ADMIN_LABELS
    if (!canSeeAdmin) {
      try {
        const before = singleMenu.items || [];
        const filtered = before.filter(
          it => !ADMIN_LABELS.includes((it?.label || "").trim())
        );

        // Some Wix environments allow reassigning .items; others don’t.
        // If it works—great. If not, it will throw and we’ll just log info.
        if (filtered.length !== before.length) {
          singleMenu.items = filtered; // may throw if read-only
          console.log("[masterPage] Filtered admin-only items from single menu");
        }
      } catch (e) {
        console.info(
          "[masterPage] Could not modify single menu items at runtime. " +
          "If you need guaranteed hiding, add two menus: #siteMenuPublic (no admin links) " +
          "and #siteMenuAdmin (with admin links).",
          e
        );
      }
    }
  }
});